import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('ItemFilter')
export class ItemFilter {
  @JsonProperty('field', String, true) field: string = undefined;
  @JsonProperty('regex', String, true) regex: string = undefined;
  @JsonProperty('negate', Boolean, true) negate = false;
}
